import { faMessage } from '@fortawesome/pro-solid-svg-icons'
import type { ReceiveSmsEvent, SendSmsEvent } from '~/domains/actions/types'
import { BaseHistoryCard } from './BaseHistoryCard'
import { HistoryItemContent } from './HistoryItemContent'

const getSmsTitle = (event: SendSmsEvent | ReceiveSmsEvent) => {
  return event.type === 'sms_sent' ? 'SMS envoyé' : 'SMS reçu'
}

export const SmsHistoryCard = ({
  event
}: {
  event: SendSmsEvent | ReceiveSmsEvent
}) => {
  return (
    <BaseHistoryCard event={event} icon={faMessage} title={getSmsTitle(event)}>
      <HistoryItemContent>{event.notes}</HistoryItemContent>
    </BaseHistoryCard>
  )
}
